<template>
  <div class="bp-checkbox-group">
    <bp-checkbox
      v-for="option in options"
      :id="option.id"
      v-model="values[option.id]"
      v-bind="option"
      :size="size"
      :key="option.id"
      @change="changeValue"
    >
      <slot :name="option.id" :option="option" />
    </bp-checkbox>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: () => "lg",
      validator: value => ["lg", "sm"].includes(value)
    }
  },
  data() {
    return {
      innerValue: this.value,
      values: {}
    };
  },
  methods: {
    changeValue(v, id) {
      let newVal = v
        ? [...this.innerValue, id]
        : this.innerValue.filter(_id => _id !== id);
      newVal = [...new Set(newVal)];
      this.innerValue = newVal;
      this.$emit("input", newVal);
    },
    setValues(val) {
      this.values = this.options.reduce((_values, option) => {
        _values[option.id] = val.includes(option.id) ? option.id : "";
        return _values;
      }, {});
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.innerValue = newVal;
        this.setValues(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.setValues(this.value);
  }
};
</script>
